import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchUserInfoFromToken } from '../../redux/slices/userSlice';
import { getBlid } from '../../utils/cookieHelpers';

/**
 * Component to initialize user data from localStorage or JWT token
 * This component doesn't render anything, it just runs initialization logic
 */
const UserInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if user is authenticated (has a valid token or SSO cookie)
    const accessToken = localStorage.getItem('access');
    const hasBlid = getBlid(); // PA_BLID cookie is only set during SSO flow

    // For SSO auth with HttpOnly cookies, we won't have an access token in localStorage
    // but we will have a PA_BLID cookie (set by BFF during SSO flow)
    // For JWT auth, we'll have an access token in localStorage
    if (accessToken || hasBlid) {
      // Fetch user info from the API using the new endpoint that works with both SSO and JWT
      // This endpoint reads from cookies (for SSO) or Authorization header (for JWT)
      dispatch(fetchUserInfoFromToken());
    }
  }, [dispatch]);

  // This component doesn't render anything
  return null;
};

export default UserInitializer;
